<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 9h-1.5c-.3-1.2-1-2.2-2-3l.5-2-2.3.7A6.4 6.4 0 0 0 12 4c-3 0-5.6 1.8-6.6 4.3H4a1 1 0 0 0-1 1v2.4a1 1 0 0 0 .6.9l1.6.7c.3 1 .9 1.9 1.8 2.6V18h2v-1.2c.6.1 1.3.2 2 .2s1.4-.1 2-.2V18h2v-2.1c1.1-.8 1.9-2 2.2-3.4h1.3a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 9h.01" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
</svg>
</template>
